export { useWebsiteData } from "./useWebsiteData";
export type { UseWebsiteDataResult } from "../types";
